import { render, staticRenderFns } from "./CargoGeneral.vue?vue&type=template&id=727fdfc7&"
import script from "./CargoGeneral.vue?vue&type=script&lang=js&"
export * from "./CargoGeneral.vue?vue&type=script&lang=js&"
import style0 from "./CargoGeneral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoGeneral.vue"
export default component.exports